import React from 'react';
const SwitchButton = props => {
    const { style, className, onClick, selectBoyUrl, selectGirlUrl, switchOn } = props;
    return (React.createElement("div", { onClick: onClick, style: style, className: className },
        React.createElement("img", { src: switchOn ? selectGirlUrl : selectBoyUrl, alt: "", style: {
                width: '100%',
            } })));
};
export default SwitchButton;
